import { ValidationStatuses } from 'enums'

import type { Result } from 'services/results/types'

import { isDifferentRequester, isReRequest, isResultPendingVerification } from '../utils'

interface UseResultAlertsProps {
  result: Result | undefined
}

const useResultAlerts = ({ result }: UseResultAlertsProps) => {
  const _isReRequest = !!result && isReRequest(result)
  const _isPending = !!result && isResultPendingVerification(result)
  const _isDifferentRequester = !!result && isDifferentRequester(result)

  const showReRequestByDifferentUserAlert = _isReRequest && _isPending && _isDifferentRequester

  const showReRequestWithUpdatedFileAlert =
    _isReRequest && _isPending && result.fileChangeStatus === 'changed' && !showReRequestByDifferentUserAlert

  const showReRequestAutoApprovedAlert =
    _isReRequest && !_isDifferentRequester && result.validationStatus === ValidationStatuses.ReRequestAutoApproved

  return {
    showReRequestWithUpdatedFileAlert,
    showReRequestByDifferentUserAlert,
    showReRequestAutoApprovedAlert
  }
}

export default useResultAlerts
